import { observable } from 'mobx';


export class ConfigStore {
  @observable links$ = {
    facebook: 'http://www.facebook.com/tierverhaltenberlin/',
    twitter: 'http://www.twitter.com/tierverhaltenb/',
    instagram: 'http://www.instagram.com/tierverhaltenberlin/',
    blog: 'https://medium.com/@tierverhaltenb/',
  };
}



// WEBPACK FOOTER //
// ./src/modules/config/config.store.js